<template>
    <tr class="core_waybill center aligned" :class="{negative: core_waybill.is_deleted}">
        <td v-if="show_update_button">
            <button class="ui basic positive icon button" @click="add_to_quick_update" v-if="!core_waybill.is_deleted">
                <i class="plus icon"></i>
            </button>
        </td>
        <td v-for="column in columns">
            <span v-if="column.display_type == 'text'">{{ core_waybill[column.name] || '-' }}</span>
            <span v-if="column.display_type == 'status'">
                <div class="ui list">
                    <div class="item">{{ human_status(core_waybill.latest_status) || $t('ui.toolbox.core_waybills.no_station') }}</div>
                    <div class="item" v-for="parent_core_waybill in core_waybill.parent_core_waybills">
                        <!-- 包裝於 -->
                        {{ $t('ui.toolbox.core_waybills.packed_in') }}
                        <router-link :to="router_link_params(core_waybill)">
                            {{ parent_core_waybill.number }}
                        </router-link>
                        : {{ human_status(parent_core_waybill.latest_status) || $t('ui.toolbox.core_waybills.no_station') }}
                    </div>
                </div>
            </span>
            <span v-if="column.display_type == 'material'">{{ material(column) || '-' }}</span>
            <span v-if="column.display_type == 'boolean'">
                <i class="check icon" v-if="core_waybill[column.name] == true"></i>
                <i class="remove icon" v-if="core_waybill[column.name] == false"></i>
            </span>
        </td>
        <td v-if="is_loading">
            <div class="ui active centered inline loader"></div>
        </td>
        <td v-else>
            <span v-if="core_waybill.is_deleted">
                <!-- 已刪除 -->
                {{ $t('ui.toolbox.core_waybills.deleted') }}
            </span>
            <div class="ui vertical buttons">
                <router-link :to="router_link_params(core_waybill)" class="ui basic primary button" v-if="!core_waybill.is_deleted">
                    {{ $t('ui.general.detail') }}
                </router-link>
                <button class="ui basic negative button" v-if="show_delete_button && core_waybill.is_deleted == false" @click.prevent="delete_core_waybill()">
                    {{ $t('ui.general.delete') }}
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        columns: Array,
        theme: {
            type: String,
            default: "default",
        },
        core_waybill: {
            type: Object,
            default() {
                return {}
            },
        },
        scope: String,
        show_delete_button: Boolean,
        show_update_button: Boolean,
    },
    data() {
        return {
            is_loading: false,
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        human_status(status) {
            try {
                return status.name
            } catch (e) {
                return null
            }
        },
        material(column) {
            try {
                return this.core_waybill.material.name
            } catch (e) {
                return null
            }
        },
        router_link_params(core_waybill) {
            switch (this.scope) {
                case "provider":
                    return {name: 'edit_core_waybill', params: {identity: core_waybill.identity}}
                    break
                case "customer":
                    return {name: 'customer_show_core_waybill', params: {identity: core_waybill.identity}}
                    break
            }
        },
        delete_core_waybill() {
            if (confirm(
                this.$t('ui.notifications.warning.are_you_sure_to_delete_it') + '\n' +
                this.$t('ui.general.delete') + ' ' + this.core_waybill.number + "？"
            )) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_delete).parse(
                    {
                        "core_waybill_identity": this.core_waybill.identity,
                    },
                    ""
                )
                var token = localStorage.getItem("authentication_token")

                axios.get(url, {headers: { Authorization: token }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.core_waybill.is_deleted = true
                            // this.$noty.success('刪除' + this.core_waybill.number + '成功')
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.core_waybill.number
                                })
                            )
                        } else {
                            console.log(response.data)
                            // this.$noty.error('刪除' + this.core_waybill.number + '失敗')
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.core_waybill.number
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                        // this.$noty.error('刪除' + this.core_waybill.number + '失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.core_waybill.number
                            })
                        )
                    }).finally(() => {
                        this.is_loading = false
                    })
            }
        },
        add_to_quick_update() {
            if (!_.find(this.$parent.quick_update_core_waybills, (o) => {
                return o.identity == this.core_waybill.identity
            })) {
                this.$parent.quick_update_core_waybills.push(_.cloneDeep(this.core_waybill))
                this.$noty.success(
                    this.core_waybill.number + ' ' +
                    this.$t('ui.toolbox.core_waybills.add_table')
                )
            }
        }
    },
    components: {
    }
}
</script>

<style scoped>
</style>
